const STORAGE_KEY = 'incyia.entityNav'
export const ENTITY_NAV_EVENT = 'incyia-entity-nav'

export type EntityNavContext = {
  missionId?: string
  missionLabel?: string
  pipelineId?: string
  pipelineLabel?: string
  projectId?: string
  projectLabel?: string
  taskId?: string
  taskLabel?: string
  auditId?: string
  auditLabel?: string
  incidentId?: string
  incidentLabel?: string
  riskId?: string
  riskLabel?: string
  planId?: string
  planLabel?: string
}

function emit() {
  try {
    window.dispatchEvent(new Event(ENTITY_NAV_EVENT))
  } catch {
    // ignore
  }
}

export function readEntityNav(): EntityNavContext {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return {}
    return JSON.parse(raw) as EntityNavContext
  } catch {
    return {}
  }
}

export function writeEntityNav(patch: EntityNavContext) {
  try {
    const next = { ...readEntityNav(), ...patch }
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next))
    emit()
  } catch {
    // ignore quota / private mode
  }
}

export function subscribeEntityNav(listener: () => void) {
  window.addEventListener(ENTITY_NAV_EVENT, listener)
  return () => window.removeEventListener(ENTITY_NAV_EVENT, listener)
}
